import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.material.teal.light.css';
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'


import '@/assets/css/normalize.css'
import '@/assets/css/boxmodel.css'
import '@/assets/css/header.css'
import '@/assets/css/footer.css'
import '@/assets/css/animation.css'
import '@/assets/css/stile.css'



createApp(App)
.use(store)
.use(router)
.mount('#app')
